<template>
  <div>
    <div v-if="defecations.length > 0 || temperatures.length > 0 || milks.length > 0 || sleeps.length > 0 ">
      <div
        class="d-flex align-center mb-2"
        v-for="(temperature, index) in temperatures"
        :key="`${index}-temperature`"
        @click="changeTemperature(temperature)"
      >
        <div class="text-grey">{{ formatTime(temperature.recordedAt) }}</div>
        <v-chip color="temperature" class="ml-4" variant="outlined" size="x-small">体温</v-chip>
        <div class="ml-4">{{ temperature.temperature.toFixed(1) }}℃</div>
      </div>
      <div
        class="d-flex align-center mb-2"
        v-for="(defecation, index) in defecations"
        :key="`${index}-defecation`"
        @click="changeDefecation(defecation)"
      >
        <div class="text-grey">{{ formatTime(defecation.recordedAt) }}</div>
        <v-chip color="defecation" class="ml-4" variant="outlined" size="x-small">排便</v-chip>
        <div class="ml-4">{{ showDefecationStatus(defecation.state) }}</div>
      </div>
      <div
        class="d-flex align-center mb-2"
        v-for="(milk, index) in milks"
        :key="`${index}-milk`"
        @click="changeMilk(milk)"
      >
        <div class="text-grey">{{ formatTime(milk.recordedAt) }}</div>
        <v-chip color="milk" class="ml-4" variant="outlined" size="x-small">{{ categoryToText(milk.milkCategory) }}</v-chip>
        <div class="ml-4">{{ milk.amount? milk.amount.value + 'cc': '不明'  }}</div>
      </div>
      <div
        class="d-flex align-center mb-2"
        v-for="(sleep, index) in sleeps"
        :key="`${index}-sleep`"
        @click="changeSleep(sleep)"
      >
        <div class="text-grey">ー：ー</div>
        <v-chip color="sleep" class="ml-4" variant="outlined" size="x-small">睡眠</v-chip>
        <div class="ml-4">{{ formatTime(sleep.from) }} 〜 {{ formatTime(sleep.to) }}</div>
      </div>
    </div>
    <div v-else style="font-size: 10px;">
      記録がありません
    </div>
  </div>
</template>
<script lang="ts">
import { diaryReportModule } from '@/store/dataModules/diaryReportModule';
import { when } from '@/service/Switch';
import {
  DefecationStatusType,
  NurseryChildResponse,
  NurseryClassResponse,
  NurseryDailyReportResponse,
  NurseryDefecationResponse,
  NurseryMilkResponse,
  NurseryTemperatureResponse,
  SleepResponse,
} from 'chaild-api/lib';
import dayjs from 'dayjs';
import Vue, { PropType, defineComponent } from 'vue';
export default defineComponent({
  props: {
    classOtherReport: {
      type: Array as PropType<NurseryDailyReportResponse[] | null>,
      required: true,
      default: [],
    },
    child: {
      type: Object as PropType<NurseryChildResponse>,
      required: true,
    },
  },
  data: () => {
    return {};
  },
  computed: {
    defecations(): NurseryDefecationResponse[] {
      if (this.classOtherReport) {
        if (this.classOtherReport.length > 0) {
          const find = this.classOtherReport.find(
            defecation => defecation.childId === this.child.childId
          );
          if (find) {
            return find.defecations;
          }
        }
      }
      return [];
    },
    temperatures(): NurseryTemperatureResponse[] {
      if (this.classOtherReport) {
        if (this.classOtherReport.length > 0) {
          const find = this.classOtherReport.find(
            temperature => temperature.childId === this.child.childId
          );
          if (find) {
            return find.temperatures;
          }
        }
      }
      return [];
    },
    milks(): NurseryMilkResponse[] {
      if (this.classOtherReport) {
        if (this.classOtherReport.length > 0) {
          const find = this.classOtherReport.find(milk => milk.childId === this.child.childId);
          if (find) {
            return find.milks;
          }
        }
      }
      return [];
    },
    sleeps(): SleepResponse[] {
      if (this.classOtherReport) {
        if (this.classOtherReport.length > 0) {
          const find = this.classOtherReport.find(sleep => sleep.childId === this.child.childId);
          if (find) {
            return find.sleeps;
          }
        }
      }
      return [];
    },
  },
  methods: {
    changeDefecation(defecation: NurseryDefecationResponse) {
      this.$emit('changeDefecation', defecation, this.child);
    },
    changeTemperature(temperature: NurseryTemperatureResponse) {
      this.$emit('changeTemperature', temperature, this.child);
    },
    changeMilk(milk: NurseryMilkResponse) {
      this.$emit('changeMilk', milk, this.child);
    },
    changeSleep(sleep: SleepResponse) {
      this.$emit('changeSleep', sleep, this.child);
    },
    showDefecationStatus(state: DefecationStatusType) {
      if (state === 'hard') {
        return '硬い';
      } else if (state === 'normal') {
        return '普通';
      } else if (state === 'soft') {
        return '柔らかい';
      } else if (state === 'diarrhea') {
        return '水様便（下痢）';
      }
    },
    formatTime(time: string) {
      const nowTime = dayjs(time).format('HH:mm');
      return nowTime;
    },
    categoryToText(milkCategory: string): string {
      return  when(milkCategory)
        .on((v) => v === 'formula', () => 'ミルク')
        .on((v) => v === 'breast', () => '母乳')
        .otherwise(() => '');
    },
  },
  mounted: async function() {},
});
</script>
<style lang="scss" scoped></style>
